import React from "react";
import { CheckCircle } from "@phosphor-icons/react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import CTASection from "@/components/CTASection";
import { INDUSTRIES } from "@/lib/site";

export default function Industries() {
  return (
    <>
      <SEO title="Industries Served" description="Empire Serv supports medical, government, industrial, office, education, and food-service facilities." path="/industries" />
      <PageHero
        eyebrow="Industries Served"
        title="One playbook, six sectors, zero shortcuts."
        subtitle="Each program is tuned to the regulatory environment, traffic profile, and risk appetite of your industry."
        image="https://images.pexels.com/photos/36286291/pexels-photo-36286291.jpeg"
        testId="industries-hero"
      />

      <section className="bg-white">
        {INDUSTRIES.map((ind, i) => (
          <div key={ind.slug} className={`es-section ${i % 2 === 1 ? "bg-[var(--es-bg)]" : "bg-white"}`} data-testid={`industry-section-${ind.slug}`}>
            <div className="es-container grid lg:grid-cols-12 gap-10 items-center">
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
                <div className="relative overflow-hidden rounded-sm">
                  <img src={ind.image} alt={ind.name} className="w-full h-[360px] object-cover" />
                  <div className="absolute top-0 left-0 w-1 h-full bg-[var(--es-accent)]" />
                </div>
              </div>
              <div className={`lg:col-span-6 ${i % 2 === 1 ? "lg:order-1" : ""}`}>
                <div className="es-eyebrow">Sector 0{i + 1}</div>
                <h2 className="es-h2 text-[var(--es-navy)] mt-3">{ind.name}</h2>
                <p className="es-lede mt-4">Programs designed for the cleanliness, compliance, and reporting expectations of {ind.name.toLowerCase()} clients.</p>
                <ul className="mt-6 space-y-3">
                  {ind.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-sm">
                      <CheckCircle size={20} weight="fill" className="text-[var(--es-accent)] flex-shrink-0 mt-0.5" />
                      <span className="text-[var(--es-text)] leading-relaxed">{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        ))}
      </section>

      <CTASection />
    </>
  );
}
